import { z } from 'zod';
import { LocationStatusSchema } from './location-schemas.js';
// UserRole enum — mirrors RoleName in backend identity domain and Prisma UserRole enum
export const UserRoleSchema = z.enum(['super_admin', 'org_admin', 'supervisor', 'operator']);
// Shared between backend (controller DTO + use case input) and frontend (form
// + API client). Location assignments are M:N junction between User and Location,
// scoped by org, managed by Org Admins (JQ4-12 / US-ORG-004).
export const AssignUserInputSchema = z.object({
    userId: z.string().uuid(),
});
export const LocationAssignmentResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    locationId: z.string().uuid(),
    userId: z.string().uuid(),
    assignedById: z.string().uuid().nullable(),
    createdAt: z.string(),
});
export const AssignedUserResponseSchema = z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().nullable(),
    role: UserRoleSchema,
    active: z.boolean(),
    assignedAt: z.string(),
    assignedById: z.string().uuid().nullable(),
});
export const ListAssignedUsersResponseSchema = z.object({
    items: z.array(AssignedUserResponseSchema),
    page: z.number().int().min(1),
    limit: z.number().int().min(1),
    total: z.number().int().min(0),
});
export const AssignedLocationResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    name: z.string(),
    address: z.string(),
    timezone: z.string(),
    status: LocationStatusSchema,
    assignedAt: z.string(),
});
export const ListLocationsForUserResponseSchema = z.object({
    locations: z.array(AssignedLocationResponseSchema),
});
export const MyLocationsResponseSchema = z.object({
    locations: z.array(AssignedLocationResponseSchema),
    isUnrestricted: z.boolean(),
});
//# sourceMappingURL=location-assignment-schemas.js.map